import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';
import getCollections from './getCollections';
import { Collection } from '@/types/other';
import type { CollectionQueryName } from '@/utilites/strapi-proxy-queries';

async function getCollectionsUseQuery(
  context: QueryFunctionContext<QueryKey>
): Promise<Collection[] | null> {
  const [, name, locale] = context.queryKey as [string, CollectionQueryName, string];
  return await getCollections(name, locale);
}

export default getCollectionsUseQuery;
